export default __webpack_public_path__ + "static/media/unhcr.fb46d686.jpg";